import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import Simulation1 from "../../assets/image/simulation/simulation1.png";
import Simulation2 from "../../assets/image/simulation/simulation2.png";
import Simulation3 from "../../assets/image/simulation/simulation3.png";
import Simulation4 from "../../assets/image/simulation/simulation4.png";

const Simulation = ({ open, handleClose, setBroker }) => {
  const [isError, setIsError] = useState(false);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [loader, setLoader] = useState(false);
  const stocks = [
    {
      label: "WeBull",
      value: "WeBull",
    },
    {
      label: "J.P. Morgan",
      value: "J.P. Morgan",
    },
    {
      label: "Fidelity Investments",
      value: "Fidelity Investments",
    },
    {
      label: "Robinhood",
      value: "Robinhood",
    },
    {
      label: "TD Ameritrade",
      value: "TD Ameritrade",
    },
    {
      label: "TastyTrade",
      value: "TastyTrade",
    },
    {
      label: "Merrill Edge",
      value: "Merrill Edge",
    },
    {
      label: "eToro",
      value: "eToro",
    },
    {
      label: "Vanguard",
      value: "Vanguard",
    },
    {
      label: "SoFi Invest",
      value: "SoFi Invest",
    },
    {
      label: "E*Trade",
      value: "E*Trade",
    },
    {
      label: "Zacks Trade",
      value: "Zacks Trade",
    },
  ];

  const handleChange = (e) => {
    if (e?.target?.value === "") {
      setIsError(true);
      setSelectedBroker(null);
    } else {
      setSelectedBroker(e?.target?.value);
    }
  };

  const handleConfirm = () => {
    if (selectedBroker && selectedBroker !== "") {
      setLoader(true);
      setTimeout(() => {
        setBroker(selectedBroker);
        setLoader(false);
        handleClose();
      }, 5000);
    } else {
      setIsError(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <div className="flex justify-between">
          <div>
            <div className="font-bold">Connect Your Broker</div>
            <div className="text-[10px] text-[#7A86A1]">
              Select your broker below
            </div>
          </div>
          {loader ? (
            ""
          ) : (
            <div>
              <IconButton
                sx={{
                  backgroundColor: "#B9B9B9",
                  padding: 0,
                  color: "#fff",
                }}
                onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
          )}
        </div>
      </DialogTitle>
      {loader ? (
        <DialogContent>
          <div className="p-12">
            <div className="text-center mb-2">
              Please wait connecting to the broker
            </div>
            <div className="font-bold text-center mb-2 text-[20px]">
              {selectedBroker || "Broker"}
            </div>
            <div className="text-center">
              <CircularProgress />
            </div>
          </div>
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <img src={Simulation2} className="rounded-[10px]" />
              <p className="text-center  text-[10px] text-[#7A86A1]">E-Trade</p>
            </Grid>
            <Grid item xs={3}>
              <img src={Simulation4} className="rounded-[10px]" />
              <p className="text-center  text-[10px] text-[#7A86A1]">
                ThinkOrSwim
              </p>
            </Grid>
            <Grid item xs={3}>
              <img src={Simulation1} className="rounded-[10px]" />
              <p className="text-center text-[10px] text-[#7A86A1]">
                Interactive Brokers
              </p>
            </Grid>

            <Grid item xs={3}>
              <img src={Simulation3} className="rounded-[10px]" />
              <p className="text-center  text-[10px] text-[#7A86A1]">
                Charles Schwab
              </p>
            </Grid>
          </Grid>
          <Grid container spacing={2} pt={2} display="flex" alignItems="center">
            <Grid item xs={8}  >
              <FormControl fullWidth >
                <InputLabel id="demo-simple-select-label">
                  More Broker
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={age}
                  sx={{
                    height: 50
                  }}
                  label="More Broker"
                  onChange={handleChange}>
                  {stocks?.map((item, i) => {
                    return (
                      <MenuItem key={i} value={item?.value}>
                        {item?.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              {isError ? (
                <p className="text-red text-[10px] text-[red]">Please select broker</p>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={4}  >
              <button
                className="text-white bg-[#0061FC] p-3 w-[100%] text-[14px] rounded-md"
                onClick={handleConfirm}>
                Confirm
              </button>
            </Grid>
          </Grid>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default Simulation;
